import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function ExpertDetailModal({ expert, onClose }) {
    const cardRef = useRef(null);
    const closeBtnRef = useRef(null);

    useEffect(() => {
        if (!expert) return;
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
        setTimeout(() => closeBtnRef.current?.focus(), 30);
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [expert, onClose]);

    if (!expert) return null;

    return createPortal(
        <div className="cv2" data-testid="v2-expert-detail-portal-root">
            <div
                className="expert-detail-overlay"
                role="dialog"
                aria-modal="true"
                aria-labelledby="expert-detail-title"
                onMouseDown={(e) => {
                    if (e.target === e.currentTarget) onClose();
                }}
                data-testid="v2-expert-detail-overlay"
            >
                <div className="expert-detail-card" ref={cardRef}>
                    <button
                        type="button"
                        className="expert-detail-close"
                        onClick={onClose}
                        ref={closeBtnRef}
                        aria-label="Close expert profile"
                        data-testid="v2-expert-detail-close"
                    >
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.4"
                            strokeLinecap="round"
                        >
                            <line x1="5" y1="5" x2="19" y2="19" />
                            <line x1="19" y1="5" x2="5" y2="19" />
                        </svg>
                    </button>

                    <div className="expert-detail-head">
                        <img
                            className="expert-detail-photo"
                            src={expert.img}
                            alt={expert.alt}
                        />
                        <div>
                            <h3
                                id="expert-detail-title"
                                className="expert-detail-name"
                                data-testid="v2-expert-detail-name"
                            >
                                {expert.name}
                            </h3>
                            <p className="expert-detail-role">{expert.role}</p>
                        </div>
                    </div>

                    <div
                        className="expert-detail-body"
                        data-testid="v2-expert-detail-body"
                    >
                        {expert.bio.map((para, i) => (
                            <p key={i} className="expert-detail-para">
                                {para}
                            </p>
                        ))}
                    </div>

                    <div className="expert-detail-expertise">
                        <div className="expert-detail-expertise-label">
                            Expertise
                        </div>
                        <ul className="expert-detail-expertise-list">
                            {expert.expertise.map((item, i) => (
                                <li
                                    key={i}
                                    className="expert-detail-expertise-item"
                                >
                                    <span
                                        className="expert-detail-expertise-dot"
                                        aria-hidden="true"
                                    />
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
}
